import axios from 'axios';
import { certificateFileUrl, mediaUrl, BRAND_SLUG } from './api/adminBrands'

const IMAGE_FOLDERS = {
  products: `${BRAND_SLUG}/product`,
  product: `${BRAND_SLUG}/product`,
  certificates: `${BRAND_SLUG}/certificates`,
  news: `${BRAND_SLUG}/content/cover`,
  banners: `${BRAND_SLUG}/content/cover`,
}

export default function () {
  const getStaticImage = (type, name) => {
    if (typeof name === 'string' && (name.startsWith('http') || name.startsWith('//') || name.startsWith('/'))) {
      return type === 'certificates' ? certificateFileUrl(name) : mediaUrl(name)
    }
    if (typeof type === 'string' && (type.startsWith('http') || type.startsWith('//') || type.startsWith('/'))) {
      return mediaUrl(type)
    }
    if (type === 'certificates') {
      return certificateFileUrl(name)
    }
    const folder = IMAGE_FOLDERS[type] || `${BRAND_SLUG}/${type || ''}`
    if (!name) return mediaUrl(`/${folder}`)
    return mediaUrl(`/${folder}/${String(name).replace(/^\/+/, '')}`)
  }

  const isObjectEmpty = (obj) => obj === 'undefined' || obj === null;

  const fetchData = async (action, target) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/${action}/${target}`)
      return response.data
    } catch (e) {
      console.warn('API request failed:', e.message, `[${action}/${target}]`)
      return null
    }
  };

  const getRequireJson = (filename) => {
    try {
      return require("./assets/data/" + filename)
    } catch (e) {
      console.log('We have the error', e)
    }
    return null
  };

  return { getStaticImage, isObjectEmpty, fetchData, getRequireJson };
}
